export const noteFeedFlexPaneTitle = "aBa";
export default {noteFeedFlexPaneTitle};